import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Divider, Form, Header } from 'semantic-ui-react'
import Input from '../Forms/Input'
import Select from '../Forms/Select'
import UsersStore from '../../stores/UsersStore'
import { observer } from 'mobx-react'

@observer
class UserForm extends Component {
  static propTypes = {
    usersStore: PropTypes.instanceOf(UsersStore).isRequired,
    roles: PropTypes.array.isRequired,
    equipments: PropTypes.array.isRequired
  }

  render () {
    const { roles, equipments, usersStore } = this.props
    return (
      <Form>
        <Form.Group widths='equal'>
          <Input name='user.first_name' store={usersStore} label='Prénom' />
          <Input name='user.last_name' store={usersStore} label='Nom' />
        </Form.Group>
        <Form.Group widths='equal'>
          <Input name='user.code' store={usersStore} label='Code employé' />
          <Input name='user.email' store={usersStore} label='Courriel' />
        </Form.Group>
        <Form.Group widths='equal'>
          <Input name='user.title' store={usersStore} label='Titre' />
          <Input name='user.mobile' store={usersStore} label='Mobile' />
        </Form.Group>
        <Form.Group widths='equal'>
          <Select
            name='user.role_id' store={usersStore} label="Type d'utilisateur" options={roles.map(role => {
              return { value: role.id, text: role.name }
            })}
          />
          <Select
            name='user.equipments._ids' store={usersStore} label="Type d'équipement"
            defaultValue={[]}
            options={equipments.map(equipment => {
              return { value: equipment.id, text: equipment.name }
            })} multiple
          />
        </Form.Group>
        <Form.Group>
          <Input width='8' name='user.password' store={usersStore} label='Mot de passe' type='password' />
        </Form.Group>
        <Divider />
        <Header as='h2'>Informations supplémentaires pour inspecteur</Header>
        <Form.Group widths='equal'>
          <Input name='user.serial_number' store={usersStore} label='Numéro de serie' />
          <Input name='user.certificate_number' store={usersStore} label='Numéro de certification' />
        </Form.Group>
      </Form>
    )
  }
}

export default UserForm
